import { HttpHeaders } from '@angular/common/http';

export function getToken(): string {
  return localStorage.getItem('access_token') || '';
}
export function getRefreshToken(): string {
  return localStorage.getItem('refresh_token') || '';
}
export function getHeaders(): HttpHeaders {
  let token: string = getToken();
  return new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });
}
